export default "__VITE_ASSET__C5EVre6g__"